import { Separator } from '~/components/ui'
import MapMinMaxFilter from './min-max'

type MapPropertyFilterProps = {
  maxAcres?: number
  minAcres?: number
  maxBsf?: number
  minBsf?: number
  updateFilter: (key: string, value: any) => void
}

export default function MapPropertyFilter({
  maxAcres,
  minAcres,
  maxBsf,
  minBsf,
  updateFilter,
}: MapPropertyFilterProps) {
  return (
    <div className="space-y-2">
      <Separator />
      <p className="font-semibold">Property</p>
      <MapMinMaxFilter
        minName="min_bsf"
        maxName="max_bsf"
        label="Building SF"
        end="SF"
        min={minBsf}
        max={maxBsf}
        updateFilter={updateFilter}
      />
      <MapMinMaxFilter
        minName="min_acres"
        maxName="max_acres"
        label="Acres"
        end="ac"
        min={minAcres}
        max={maxAcres}
        updateFilter={updateFilter}
      />
    </div>
  )
}
